import i18n from './../../../shared/i18n';

import BaseModel from "../../../core/components/input-widget/BaseModel";
import {getPasswordRegex, getPhoneRuleObj} from "@/plugins/vee-validate";

export default class UserForm extends BaseModel {
  uuid = null;
  first_name = '';
  last_name = '';
  email = '';
  phone = '';
  password = '';
  repeat_password = '';
  csv_export_delimiter = null;
  preferred_language = null;
  address_1 = null;
  address_2 = null;
  city = null;
  county = null;
  state = null;
  zip_code = null;
  country_code = null;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  rules = {
    email: 'required|email|max:73',
    first_name: 'required',
    last_name: 'required',
    phone: getPhoneRuleObj(false),
    password: getPasswordRegex(false, {
      confirmed: 'repeat_password'
    }),
    repeat_password: 'confirmed:password',
  };

  attributeHints = {
    first_name: i18n.t('First Name'),
    last_name: i18n.t('Last Name'),
    email: i18n.t('Email'),
    phone: i18n.t('Phone'),
    password: i18n.t('Password'),
    repeat_password: i18n.t('Repeat Password'),
  };

  attributeLabels = {
    first_name: i18n.t('First Name'),
    last_name: i18n.t('Last Name'),
    email: i18n.t('Email'),
    phone: i18n.t('Phone'),
    password: i18n.t('Password'),
    repeat_password: i18n.t('Repeat Password'),
    preferred_language: i18n.t('Preferred Language'),
    csv_export_delimiter: i18n.t('CSV Export Delimiter'),
    address_1: i18n.t('Address 1'),
    address_2: i18n.t('Address 2'),
    city: i18n.t('City'),
    state: i18n.t('State'),
    county: i18n.t('County'),
    zip_code: i18n.t('Zip/Postcode'),
    country_code: i18n.t('Country'),
  }

  getDataForUserFormSubmission() {
    const params = Object.assign({}, {
      first_name: this.first_name,
      last_name: this.last_name,
      email: this.email,
      phone: this.phone,
      password: this.password,
    });

    params.tags = params.tags.join(',');

    return params;
  }
}
